import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "@/lib/site";

export const Upcoming = () => {
  return (
    <section
      id="upcoming"
      data-testid="upcoming-section"
      className="relative scroll-mt-nav py-28 md:py-36 bg-[#0A0D14]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-baseline justify-between mb-12">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-[#2DD4BF]">04 · The Slate Ahead</p>
            <h2 className="font-serif text-4xl md:text-5xl text-white mt-3">Upcoming Projects</h2>
          </div>
          <span className="hidden md:inline text-xs tracking-[0.25em] uppercase text-slate-500">
            2025 · 2026
          </span>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {PROJECTS.upcoming.map((p, idx) => (
            <div
              key={p.title}
              data-testid={`upcoming-card-${p.title.toLowerCase()}`}
              className="relative h-[520px] rounded-3xl overflow-hidden border border-white/8 hover-lift group"
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                style={{ backgroundImage: `url(${p.bg})` }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/60 to-black/20" />

              <div className="relative h-full flex flex-col justify-between p-8">
                <div className="flex items-center justify-between">
                  <span className="px-3 py-1.5 rounded-full bg-black/60 backdrop-blur text-[10px] tracking-[0.25em] uppercase text-[#2DD4BF] border border-[#2DD4BF]/30">
                    {p.tag}
                  </span>
                  <span className="font-serif text-sm text-slate-400">0{idx + 2}</span>
                </div>

                <div>
                  <h3 className="font-serif text-5xl md:text-6xl text-white leading-none">
                    {p.title}
                  </h3>
                  <p className="text-slate-300 mt-4 max-w-md leading-relaxed">{p.blurb}</p>

                  <div className="mt-6 flex flex-wrap gap-2">
                    {p.languages.map((l) => (
                      <span key={l} className="lang-pill">{l}</span>
                    ))}
                  </div>

                  <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#D4AF37] tracking-wide">
                    Details on announcement
                    <ArrowUpRight size={16} />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
